import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';

var updateCustomOptions = function updateCustomOptions(options) {
  return function (prev) {
    var toAdd = options.filter(function (option) {
      var id = option.id.toString();
      return id.startsWith('@@') && !prev.includes(option);
    });
    if (toAdd.length > 0) {
      return [].concat(_toConsumableArray(prev), _toConsumableArray(toAdd));
    }
    return prev;
  };
};

export { updateCustomOptions };
